import { Component, OnInit, ElementRef, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { EventEmitterService } from '../../services/event-emitter/event-emitter.service';

declare var $: any;

@Component({
  selector: 'app-modal-detail',
  templateUrl: './modal-detail.component.html',
  styleUrls: ['./modal-detail.component.scss']
})
export class ModalDetailComponent implements OnInit, OnChanges {
  @Input() public isAlert: boolean;
  @Input() public showModal: boolean;
  @Output() public eventClose: EventEmitter<any> = new EventEmitter();

  constructor(
    private elRef: ElementRef
  ) { }

  ngOnInit() {
    this.clickOutListener();

    EventEmitterService.get('close-modal-detail').subscribe(() => {
      this.closeModal();
    });
  }

  ngOnChanges(changes) {
    changes && changes.showModal && changes.showModal.currentValue ? this.openModal() : this.closeModal();
  }

  openModal() {
    this.elRef.nativeElement.querySelector('.modal-detail-container').classList.add('show-modal-detail');
    this.elRef.nativeElement.querySelector('.modal-detail-container').classList.remove('hide-modal-detail');
  }

  closeModal() {
    this.elRef.nativeElement.querySelector('.modal-detail-container').classList.remove('show-modal-detail');
    this.eventClose.emit(null);
  }

  clickOutListener() {
    const self = this;
    document.addEventListener('click', function(e: any) {
      if (e.target.className === 'modal-detail-mask') { self.closeModal(); }
    });
  }
}
